import { render, staticRenderFns } from "./popups.vue?vue&type=template&id=8dbb2238"
import script from "./popups.vue?vue&type=script&lang=js"
export * from "./popups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\GitWorkplace\\物联网\\tenda_iot_system\\node_modules\\_vue-hot-reload-api@2.3.4@vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8dbb2238')) {
      api.createRecord('8dbb2238', component.options)
    } else {
      api.reload('8dbb2238', component.options)
    }
    module.hot.accept("./popups.vue?vue&type=template&id=8dbb2238", function () {
      api.rerender('8dbb2238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/plugins/components/slider/popups.vue"
export default component.exports